module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C3veVn/tc-custom/9781439633106.jpg?1700070684457",
      "alt": "This image is the cover for the book Motor City Mafia, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Motor City Mafia, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Learn the story behind one of Detroit's most infamous mobs with rare photographs documenting their rise and fall.")])]), _c('br'), _c('p', [_c('i', [_vm._v("Motor City Mafia: A Century of Organized Crime in Detroit")]), _vm._v(" chronicles the storied and hallowed gangland history of the notorious Detroit underworld. Scott M. Burnstein takes the reader inside the belly of the beast, tracking the bloodshed, exploits, and leadership of the southeast Michigan crime syndicate as never before seen in print. Through a stunning array of rare archival photographs and images, Motor City Mafia captures Detroit's most infamous past, from its inception in the early part of the 20th century, through the years when the iconic Purple Gang ruled the city's streets during Prohibition, through the 1930s and the formation of the local Italian mafia, and the Detroit crime family's glory days in the 1950s, 1960s, and 1970s, all the way to the downfall of the area's mob reign in the 1980s and 1990s.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Scott M. Burnstein\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Crime writer Scott M. Burnstein was born and raised in Detroit and specializes in the history of organized crime in America. Burnstein has a law degree from the John Marshall School of Law in Chicago and a bachelor's degree from Indiana University in Bloomington.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0